// import React, { useState } from "react";
// import "./Login.css";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [error, setError] = useState("");

//   const sendOtp = async () => {
//     const res = await fetch("https://lcoiapi.emedha.in/login/send-otp", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ email }),
//     });

//     const data = await res.json();
//     if (res.ok) {
//       setOtpSent(true);
//       setError("");
//     } else {
//       setError(data.message || "Failed to send OTP");
//     }
//   };

//   const verifyOtp = async () => {
//     const res = await fetch("https://lcoiapi.emedha.in/login/verify-otp", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ email, otp }),
//     });

//     const data = await res.json();
//     if (data.verified) {
//         // Inside Login.js or your auth handler
// localStorage.setItem('isAuthenticated', 'true');
// // Navigate to home


//       window.location.href = "/"; // Navigate on success
//     } else {
//       setError("Invalid OTP");
//     }
//   };

//   return (
//     <div className="login-container">
//       <h2>Email OTP Login</h2>

//       {!otpSent ? (
//         <div className="step step-1">
//           <input
//             type="email"
//             placeholder="Enter Email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//           />
//           <button onClick={sendOtp}>Send OTP</button>
//         </div>
//       ) : (
//         <div className="step step-2">
//           <input
//             type="text"
//             placeholder="Enter OTP"
//             value={otp}
//             maxLength={6}
//             onChange={(e) => setOtp(e.target.value)}
//           />
//           <button onClick={verifyOtp}>Verify OTP</button>
//         </div>
//       )}

//       {error && <p className="error">{error}</p>}
//     </div>
//   );
// };

// export default Login;

// import React, { useState } from "react";
// import "./Login.css";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [error, setError] = useState("");

//   const sendOtp = async () => {
//     const res = await fetch("https://lcoiapi.emedha.in/login/send-otp", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ email }),
//     });

//     const data = await res.json();
//     if (res.ok) {
//       setOtpSent(true);
//       setError("");
//     } else {
//       setError(data.message || "Failed to send OTP");
//     }
//   };

//   const verifyOtp = async () => {
//     const res = await fetch("https://lcoiapi.emedha.in/login/verify-otp", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ email, otp }),
//     });

//     const data = await res.json();
//     if (data.verified) {
//       localStorage.setItem("isAuthenticated", "true");
//       window.location.href = "/";
//     } else {
//       setError("Invalid OTP");
//     }
//   };

//   return (
//     <div className="login-wrapper">
//       <div className="login-box">
//         <h1 className="login-title">🔐 Secure Login</h1>
//         <p className="login-subtitle">
//           Enter your email to receive a one-time password (OTP).
//         </p>

//         {!otpSent ? (
//           <div className="form-step fade-in"> 
//             <input
//               type="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="input-field"
//             />
//             <button className="primary-btn" onClick={sendOtp}>
//               Send OTP
//             </button>
//           </div>
//         ) : (
//           <div className="form-step fade-in">
//             <input
//               type="text"
//               placeholder="Enter 6-digit OTP"
//               value={otp}
//               maxLength={6}
//               onChange={(e) => setOtp(e.target.value)}
//               className="input-field"
//             />
//             <button className="primary-btn" onClick={verifyOtp}>
//               Verify OTP
//             </button>
//           </div>
//         )}

//         {error && <p className="error-message">{error}</p>}
//       </div>
//     </div>
//   );
// };

// export default Login;


// import React, { useState } from "react";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [error, setError] = useState("");

//   const sendOtp = async () => {
//     const res = await fetch("https://lcoiapi.emedha.in/login/send-otp", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ email }),
//     });

//     const data = await res.json();
//     if (res.ok) {
//       setOtpSent(true);
//       setError("");
//     } else {
//       setError(data.message || "Failed to send OTP");
//     }
//   };

//   const verifyOtp = async () => {
//     const res = await fetch("https://lcoiapi.emedha.in/login/verify-otp", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ email, otp }),
//     });

//     const data = await res.json();
//     if (data.verified) {
//       localStorage.setItem("isAuthenticated", "true");
//       window.location.href = "/";
//     } else {
//       setError("Invalid OTP");
//     }
//   };

//   // Inline styles
//   const styles = {
//     wrapper: {
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       width: "100%",
//     },
//     box: {
//       background: "#fff",
//       padding: "30px 40px",
//       borderRadius: "12px",
//       boxShadow: "0 12px 24px rgba(0, 0, 0, 0.15)",
//       width: "100%",
//       maxWidth: "400px",
//       textAlign: "center",
//       animation: "dropFade 0.5s ease-out",
//     },
//     title: {
//       fontSize: "28px",
//       marginBottom: "10px",
//       color: "#333",
//     },
//     subtitle: {
//       fontSize: "14px",
//       color: "#666",
//       marginBottom: "25px",
//     },
//     input: {
//       width: "100%",
//       padding: "12px 16px",
//       margin: "10px 0",
//       border: "1px solid #ccc",
//       borderRadius: "8px",
//       fontSize: "16px",
//       transition: "all 0.3s ease",
//     },
//     button: {
//       width: "100%",
//       padding: "12px",
//       marginTop: "15px",
//       backgroundColor: "#007bff",
//       color: "white",
//       border: "none",
//       borderRadius: "8px",
//       fontSize: "16px",
//       cursor: "pointer",
//       transition: "background 0.3s ease",
//     },
//     error: {
//       color: "red",
//       marginTop: "12px",
//       fontSize: "14px",
//     },
//     fadeIn: {
//       animation: "fadeIn 0.6s ease-in",
//     },
//   };

//   return (
//     <div style={styles.wrapper}>
//       <div style={styles.box}>
//         <h1 style={styles.title}>🔐 Secure Login</h1>
//         <p style={styles.subtitle}>
//           Enter your email to receive a one-time password (OTP).
//         </p>

//         {!otpSent ? (
//           <div style={styles.fadeIn}>
//             <input
//               type="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               style={styles.input}
//             />
//             <button
//               style={styles.button}
//               onMouseOver={(e) => (e.target.style.backgroundColor = "#005dc1")}
//               onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
//               onClick={sendOtp}
//             >
//               Send OTP
//             </button>
//           </div>
//         ) : (
//           <div style={styles.fadeIn}>
//             <input
//               type="text"
//               placeholder="Enter 6-digit OTP"
//               value={otp}
//               maxLength={6}
//               onChange={(e) => setOtp(e.target.value)}
//               style={styles.input}
//             />
//             <button
//               style={styles.button}
//               onMouseOver={(e) => (e.target.style.backgroundColor = "#005dc1")}
//               onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
//               onClick={verifyOtp}
//             >
//               Verify OTP
//             </button>
//           </div>
//         )}

//         {error && <p style={styles.error}>{error}</p>}
//       </div>
//     </div>
//   );
// };

// export default Login;


// import React, { useState, useEffect } from "react";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [error, setError] = useState("");

//   // Set page-level styles on mount
//   useEffect(() => {
//     document.body.style.margin = "0";
//     document.body.style.fontFamily = `"Segoe UI", Tahoma, Geneva, Verdana, sans-serif`;
//     document.body.style.background = "linear-gradient(135deg, #89f7fe, #66a6ff)";
//     document.body.style.height = "100vh";
//     document.body.style.display = "flex";
//     document.body.style.alignItems = "center";
//     document.body.style.justifyContent = "center";

//     return () => {
//       // Cleanup if needed
//       document.body.removeAttribute("style");
//     };
//   }, []);

//   const sendOtp = async () => {
//     const res = await fetch("https://lcoiapi.emedha.in/login/send-otp", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ email }),
//     });

//     const data = await res.json();
//     if (res.ok) {
//       setOtpSent(true);
//       setError("");
//     } else {
//       setError(data.message || "Failed to send OTP");
//     }
//   };

//   const verifyOtp = async () => {
//     const res = await fetch("https://lcoiapi.emedha.in/login/verify-otp", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ email, otp }),
//     });

//     const data = await res.json();
//     if (data.verified) {
//       localStorage.setItem("isAuthenticated", "true");
//       window.location.href = "/leadersPage";
//     } else {
//       setError("Invalid OTP");
//     }
//   };

//   const styles = {
//     box: {
//       background: "#fff",
//       padding: "30px 40px",
//       borderRadius: "12px",
//       boxShadow: "0 12px 24px rgba(0, 0, 0, 0.15)",
//       width: "100%",
//       maxWidth: "400px",
//       textAlign: "center",
//     },
//     title: {
//       fontSize: "28px",
//       marginBottom: "10px",
//       color: "#333",
//     },
//     subtitle: {
//       fontSize: "14px",
//       color: "#666",
//       marginBottom: "25px",
//     },
//     input: {
//       width: "100%",
//       padding: "12px 16px",
//       margin: "10px 0",
//       border: "1px solid #ccc",
//       borderRadius: "8px",
//       fontSize: "16px",
//     },
//     button: {
//       width: "100%",
//       padding: "12px",
//       marginTop: "15px",
//       backgroundColor: "#007bff",
//       color: "white",
//       border: "none",
//       borderRadius: "8px",
//       fontSize: "16px",
//       cursor: "pointer",
//     },
//     error: {
//       color: "red",
//       marginTop: "12px",
//       fontSize: "14px",
//     },
//   };

//   return (
//     <div>
//       <div style={styles.box}>
//         <h1 style={styles.title}>🔐 Secure Login</h1>
//         <p style={styles.subtitle}>
//           Enter your email to receive a one-time password (OTP).
//         </p>

//         {!otpSent ? (
//           <div>
//             <input
//               type="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               style={styles.input}
//             />
//             <button
//               style={styles.button}
//               onMouseOver={(e) => (e.target.style.backgroundColor = "#005dc1")}
//               onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
//               onClick={sendOtp}
//             >
//               Send OTP
//             </button>
//           </div>
//         ) : (
//           <div>
//             <input
//               type="text"
//               placeholder="Enter 6-digit OTP"
//               value={otp}
//               maxLength={6}
//               onChange={(e) => setOtp(e.target.value)}
//               style={styles.input}
//             />
//             <button
//               style={styles.button}
//               onMouseOver={(e) => (e.target.style.backgroundColor = "#005dc1")}
//               onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
//               onClick={verifyOtp}
//             >
//               Verify OTP
//             </button>
//           </div>
//         )}

//         {error && <p style={styles.error}>{error}</p>}
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState, useEffect } from "react";
import logo from '../images/logo.png';
const Login = () => {
  const [email, setEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    document.body.style.margin = "0";
    document.body.style.fontFamily = `"Segoe UI", Tahoma, Geneva, Verdana, sans-serif`;
    document.body.style.background =
      "linear-gradient(135deg, #1c509c, #6486bb, #cdb22b, #ecfbfb, #bbddf3)";
    document.body.style.backgroundSize = "400% 400%";
    document.body.style.animation = "gradientFlow 12s ease infinite";
    document.body.style.height = "100vh";
    document.body.style.display = "flex";
    document.body.style.alignItems = "center";
    document.body.style.justifyContent = "center";

    // Inject keyframes animation
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes gradientFlow {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.body.removeAttribute("style");
      document.head.removeChild(style);
    };
  }, []);

  const sendOtp = async () => {
    const res = await fetch("https://lcoiapi.emedha.in/login/send-otp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();
    if (res.ok) {
      setOtpSent(true);
      setError("");
    } else {
      setError(data.message || "Failed to send OTP");
    }
  };

  const verifyOtp = async () => {
    const res = await fetch("https://lcoiapi.emedha.in/login/verify-otp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, otp }),
    });

    const data = await res.json();
    if (data.verified) {
      localStorage.setItem("isAuthenticated", "true");
      window.location.href = "/leadersPage";
    } else {
      setError("Invalid OTP");
    }
  };

  const styles = {
    box: {
      background: "#fff",
      padding: "40px 35px",
      borderRadius: "14px",
      boxShadow: "0 18px 40px rgba(0, 0, 0, 0.25)",
      width: "100%",
      maxWidth: "420px",
      textAlign: "center",
      transition: "transform 0.3s ease",
    },
    title: {
      fontSize: "30px",
      marginBottom: "8px",
      color: "#1c509c",
      fontWeight: 700,
    },
    subtitle: {
      fontSize: "14px",
      color: "#555",
      marginBottom: "25px",
    },
    input: {
      width: "100%",
      padding: "14px 16px",
      margin: "12px 0",
      border: "1px solid #ccc",
      borderRadius: "8px",
      fontSize: "16px",
      outline: "none",
      transition: "box-shadow 0.3s ease",
    },
    button: {
      width: "100%",
      padding: "14px",
      marginTop: "10px",
      backgroundColor: "#1c509c",
      color: "white",
      border: "none",
      borderRadius: "8px",
      fontSize: "16px",
      cursor: "pointer",
      fontWeight: "600",
      transition: "background-color 0.3s ease, transform 0.2s ease",
    },
    error: {
      color: "red",
      marginTop: "12px",
      fontSize: "14px",
    },
  };

  return (
    <div>
      <div style={styles.box}>
        <h1 style={styles.title}>
               <img
                    src={logo}
                    alt="Logo"
                    style={styles.logo}
                  /></h1>
                <h1>   🔐 Secure Login</h1>
        <p style={styles.subtitle}>
          Enter your email to receive a one-time password (OTP).
        </p>  

        {!otpSent ? (
          <div>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              onFocus={(e) =>
                (e.target.style.boxShadow = "0 0 0 2px rgba(28, 80, 156, 0.3)")
              }
              onBlur={(e) => (e.target.style.boxShadow = "none")}
            />
            <button
              style={styles.button}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#14407f";
                e.target.style.transform = "scale(1.02)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#1c509c";
                e.target.style.transform = "scale(1)";
              }}
              onClick={sendOtp}
            >
              Send OTP
            </button>
          </div>
        ) : (
          <div>
            <input
              type="text"
              placeholder="Enter 6-digit OTP"
              value={otp}
              maxLength={6}
              onChange={(e) => setOtp(e.target.value)}
              style={styles.input}
              onFocus={(e) =>
                (e.target.style.boxShadow = "0 0 0 2px rgba(28, 80, 156, 0.3)")
              }
              onBlur={(e) => (e.target.style.boxShadow = "none")}
            />
            <button
              style={styles.button}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#14407f";
                e.target.style.transform = "scale(1.02)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#1c509c";
                e.target.style.transform = "scale(1)";
              }}
              onClick={verifyOtp}
            >
              Verify OTP
            </button>
          </div>
        )}

        {error && <p style={styles.error}>{error}</p>}
      </div>
    </div>
  );
};

export default Login;
